



















import { Component, Vue } from 'vue-property-decorator';
import layout from '@/layouts/basic-layout.vue';
import LoginForm from '@/components/login-form.vue';

@Component({
    components: {
        layout,
    },
})
export default class NotFound extends Vue {}
